import { useCallback, useEffect, useState } from 'react'
import useLoggedNavigate from 'hooks/useLoggedNavigate'
import { useAuth0 } from '@auth0/auth0-react'

const LoginPage = () => {
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0()
  const nav = useLoggedNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      nav('/')
      return
    }

    if (!isLoading && !isAuthenticated) {
      console.log('Unauthenticated, redirecting to login (Login Page)')
      loginWithRedirect()
    }
  })

  return null
}

export default LoginPage
